import api from '../api';

const BASE_URL = '/api/v2/exports';

const ExportsAPI = {
	post: (payload) => api.post(BASE_URL, payload, { responseType: 'blob' }),
};

export default ExportsAPI;
